import * as formActions from 'libs/rx-state/actions';
import * as fromManager from 'libs/rx-state';

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormTemplate, SearchType } from '@nrwl/rx-models';
import { Store, select } from '@ngrx/store';
import { map, pluck, tap } from 'rxjs/operators';

import { FormTemplateFilesService } from '@nrwl/rx-service-forms';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxTabsModule } from '@nrwl/rx-tabs';
import { RxSplitViewModule } from '@nrwl/rx-split-view';

@Component({
  selector: 'rx-form-upload',
  templateUrl: './rx-form-upload.component.html',
  styleUrls: ['./rx-form-upload.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxIconModule,
    RxTabsModule,
    RxSplitViewModule,
  ],
})
export class RxFormUploadComponent implements OnInit, OnDestroy {
  @Output() event: EventEmitter<any> = new EventEmitter();
  private formTemplate: FormTemplate;
  template$;

  constructor(
    public formTemplateFilesService: FormTemplateFilesService,
    private store: Store<any>,
  ) {
    this.template$ = this.store.pipe(
      select(fromManager.getSelectedTemplate),
      tap((form) => (this.formTemplate = form)),
    );
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.store.dispatch(
      new formActions.LoadForms({
        categoryID: this.formTemplate.category,
        searchType: this.formTemplate.is_stock[0]
          ? SearchType.GlobalLibrary
          : SearchType.AccountLibrary,
      }),
    );
  }

  // TODO: Convert this to filter pipe
  getOriginalForms(template) {
    if (template) {
      return template.files.filter((file) => file.type === 0);
    }
    return [];
  }

  // TODO: Convert this to filter pipe
  getBuiltForms(template) {
    if (template) {
      return template.files.filter((file) => file.type === 1);
    }
    return [];
  }

  uploadOriginalForm($event) {
    this.formTemplateFilesService.uploadFile($event, 0);
  }

  uploadBuiltForm($event) {
    this.formTemplateFilesService.uploadFile($event, 1);
  }

  remove(file: any) {
    this.formTemplateFilesService.deleteFile(file.id).subscribe((res) => {
      this.store.dispatch(new formActions.LoadSelectedTemplate(this.formTemplate.id));
    });
  }
}
